import { UIMenuColumn } from './ui-menu-column';
import { UIMenuGroup } from './ui-menu-group';
import { UIMenuLink } from './ui-menu-link';
import { UIMenuTab } from './ui-menu-tab';

/**
 * Gets all menu tabs that are direct children of a parent element.
 */
export function getMenuTabs(parent: Element): Array<UIMenuTab> {
    return Array.from(
        parent.querySelectorAll<UIMenuTab>(':scope > ui-menu-tab')
    );
}

/**
 * Gets all menu links as direct children of a parent element.
 */
export function getMenuLinks(parent: Element): Array<UIMenuLink> {
    return Array.from(
        parent.querySelectorAll<UIMenuLink>(':scope > ui-menu-link')
    );
}

/**
 * Gets all menu columns recursively from a parent element (not just direct children).
 */
export function getMenuColumns(parent: Element): Array<UIMenuColumn> {
    return Array.from(parent.querySelectorAll<UIMenuColumn>('ui-menu-column'));
}

/**
 * Gets all menu groups recursively from a parent element (not just direct children).
 */
export function getMenuGroups(parent: Element): Array<UIMenuGroup> {
    return Array.from(parent.querySelectorAll<UIMenuGroup>('ui-menu-group'));
}

/**
 * Gets all anchor elements within menu links in a container.
 */
export function getMenuLinkAnchors(parent: Element): Array<HTMLAnchorElement> {
    return Array.from(
        parent.querySelectorAll<HTMLAnchorElement>(
            'ui-menu-link .ui-menu-link__link a'
        )
    );
}
